document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const mobileSearchInput = document.getElementById("mobile-search-input");
  const sideSearchInput = document.getElementById("side-panel-search-input");

  const searchForm = document.querySelector(".collection-filters__group-form");
  const mobileSearchForm = mobileSearchInput ? mobileSearchInput.closest("form") : null;
  const filtersForm = document.getElementById("CollectionFiltersForm");
  const submitButton = document.querySelector('.collection-filters__button[type="submit"]');
  const mobileApplyButton = document.querySelector(".mobile-filters-apply");
  const searchClearButton = document.getElementById("search-clear-button");
  const mobileSearchClearButton = document.getElementById("mobile-search-clear-button");

  if (!searchInput || !searchForm) return;

  let userHasCleared = false;
  let mobileUserHasCleared = false;

  function syncInputs(source, value) {
    [searchInput, mobileSearchInput, sideSearchInput].forEach((input) => {
      if (input && input !== source) input.value = value;
    });
  }

  function clearQueryParams() {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("q");
    currentUrl.searchParams.delete("type");
    window.location.href = currentUrl.toString();
  }

  function handleInputState(input, clearedFlagSetter) {
    if (!input) return;
    const isEmpty = input.value.trim() === "";
    clearedFlagSetter(isEmpty);

    if (isEmpty) {
      input.setAttribute("data-user-cleared", "true");
      syncInputs(input, "");
    } else {
      input.removeAttribute("data-user-cleared");
      syncInputs(input, input.value);
    }
  }

  function handleEnterSubmit(e, input, form, wasCleared) {
    if (e.key !== "Enter" && e.keyCode !== 13) return;
    e.preventDefault();

    const value = input.value.trim();

    if (wasCleared() && value === "") {
      clearQueryParams();
      return false;
    }

    if (value.length > 0 && form) {
      form.submit();
    }

    return false;
  }

  function toggleClearButton(input, button) {
    if (!input || !button) return;
    button.style.display = input.value.trim().length > 0 ? "flex" : "none";
  }

  function clearInput(input, clearedFlagSetter, button) {
    if (!input) return;
    input.value = "";
    input.setAttribute("data-user-cleared", "true");
    clearedFlagSetter(true);
    if (button) button.style.display = "none";
    syncInputs(input, "");
    input.focus();
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  searchInput.addEventListener("input", function () {
    handleInputState(searchInput, (val) => (userHasCleared = val));
    toggleClearButton(searchInput, searchClearButton);
  });

  searchInput.addEventListener("keydown", function (e) {
    handleEnterSubmit(e, searchInput, searchForm, () => userHasCleared);
  });

  searchForm.addEventListener("submit", function (e) {
    const value = searchInput.value.trim();
    if (userHasCleared && value === "") {
      e.preventDefault();
      clearQueryParams();
      return false;
    }
    return true;
  });

  if (mobileSearchInput) {
    mobileSearchInput.addEventListener("input", function () {
      handleInputState(mobileSearchInput, (val) => (mobileUserHasCleared = val));
      toggleClearButton(mobileSearchInput, mobileSearchClearButton);
    });

    mobileSearchInput.addEventListener("keydown", function (e) {
      handleEnterSubmit(e, mobileSearchInput, mobileSearchForm, () => mobileUserHasCleared);
    });
  }

  if (mobileSearchForm) {
    mobileSearchForm.addEventListener("submit", function (e) {
      const value = mobileSearchInput.value.trim();
      if (mobileUserHasCleared && value === "") {
        e.preventDefault();
        clearQueryParams();
        return false;
      }
      return true;
    });
  }

  if (submitButton && filtersForm) {
    submitButton.addEventListener(
      "click",
      function (e) {
        const value = searchInput.value.trim();
        if (userHasCleared && value === "") {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      },
      { capture: true, passive: false }
    );

    submitButton.addEventListener("click", function () {
      const value = searchInput.value.trim();
      let hiddenSearchInput = filtersForm.querySelector('input[name="q"]');

      if (value.length > 0) {
        if (!hiddenSearchInput) {
          hiddenSearchInput = document.createElement("input");
          hiddenSearchInput.type = "hidden";
          hiddenSearchInput.name = "q";
          filtersForm.appendChild(hiddenSearchInput);
        }
        hiddenSearchInput.value = value;
      } else if (hiddenSearchInput) {
        hiddenSearchInput.remove();
      }
    });
  }

  if (mobileApplyButton && mobileSearchInput) {
    mobileApplyButton.addEventListener(
      "click",
      function (e) {
        const value = mobileSearchInput.value.trim();
        if (mobileUserHasCleared && value === "") {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      },
      { capture: true, passive: false }
    );
  }

  if (searchClearButton) {
    toggleClearButton(searchInput, searchClearButton);
    searchClearButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearInput(searchInput, (val) => (userHasCleared = val), searchClearButton);
    });
  }

  if (mobileSearchClearButton && mobileSearchInput) {
    toggleClearButton(mobileSearchInput, mobileSearchClearButton);

    const clearMobile = function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearInput(
        mobileSearchInput,
        (val) => (mobileUserHasCleared = val),
        mobileSearchClearButton
      );
    };

    mobileSearchClearButton.addEventListener("click", clearMobile);
    mobileSearchClearButton.addEventListener("touchstart", clearMobile, { passive: false });
  }

  const originalValue = searchInput.dataset.originalValue || "";
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "value") {
        if (userHasCleared && searchInput.value === originalValue) {
          searchInput.value = "";
        }
      }
    });
  });

  observer.observe(searchInput, { attributes: true });
});